import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", { class: "w-100 mt-2 mb-0" }, null, -1)

import { TicketModule } from "@/store/modules/Ticket";
import { AppModule } from "@/store/modules/app";
import { IndexType } from "@/types/store";
import { computed } from "vue";

/*  => Computed */

// total buttons

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const configButtons = computed(() =>
	AppModule.userConfig?.data.filter(field => field.type === "button")
);

// buttons for this user
const userButtons = computed(
	() =>
		configButtons.value?.reduce((acc, btn) => {
			const data = TicketModule.currentTicket?.client[0]?.dynamicData?.[
				btn.name
			] as string;
			if (data)
				acc[btn.name] = { label: btn.label, value: data, icon: btn.icon };
			return acc;
		}, {} as IndexType<{ label: string; value: string; icon?: string }>) ?? {}
);

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_col = _resolveComponent("el-col")!

  return (Object.keys(_unref(userButtons)).length)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_el_col, { class: "pt-4 pb-2 d-flex align-items-center justify-content-center" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_unref(userButtons)), (btn, i) => {
              return (_openBlock(), _createBlock(_component_base_button, {
                tag: "a",
                size: "md",
                type: "warning",
                outline: "",
                key: i,
                href: btn.value,
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  (btn.icon)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(btn.icon)
                      }, null, 2))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(btn.label), 1)
                ]),
                _: 2
              }, 1032, ["href"]))
            }), 128))
          ]),
          _: 1
        }),
        _hoisted_1
      ], 64))
    : _createCommentVNode("", true)
}
}

})